<template>
    <Sidebar title="Η ΟΜΑΔΑ ΜΑΣ" :items="services"/>
</template>

<script>
import Sidebar from './Sidebar'

export default{
    name: 'white-navbar',
    components: {
        Sidebar
    },
     data () {
        return{
            services: [
                {
                    title: 'Σόνια Μεθενίτη',
                    link:'/sonia-metheniti/'
                },
                {
                    title: 'Δάφνη Βούτα',
                    link: '/dafni-vouta/'
                },
                {
                    title: 'Βασίλειος Κατσούλας',
                    link: '/vasilios-katsoulas/'
                }
               
                
            ]
        }
    }

}
</script>